export default "__VITE_ASSET__sn1HwNn9__"